module.exports = __webpack_public_path__ + "img/cwg_dukaqi.93c900e2.png";